import { Component } from '@angular/core'

import { IQuestionContextView } from '..'
import { Question } from '../../../../../data/models'
import { Form } from '../../../../../forms/models'

@Component({
  selector: 'mp-default-question-context-view',
  templateUrl: './default-question-context-view.html',
  styleUrls: ['./default-question-context-view.scss']
})
export class DefaultQuestionContextViewComponent implements IQuestionContextView {
  public question: Question
  public form: Form<Question>

  public getContextText() {
    const context = this.question.questionContext
    const hightlightData = this.question.getMetadata('question_context_highlight')
    return hightlightData ? this._addHighlight(hightlightData, context) : context.description
  }

  private _addHighlight(hightlightData, context) {
    return context.description.replace(
      hightlightData['context'],
      hightlightData['context'].replace(
        hightlightData['phrase'],
        `<span class="context-text-highlight">${hightlightData['phrase']}</span>`
      )
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/question-context-view/default-question-context-view/default-question-context-view.component.ts